import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const Snowflakes = ({ count = 100, speed = 1, size = 'medium' }) => {
  const snowflakes = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 0.5 + 0.5,
      opacity: Math.random() * 0.6 + 0.4,
      duration: (Math.random() * 10 + 10) / speed,
      delay: Math.random() * 5
    }));
  }, [count, speed]);

  const getSizeClass = (snowflake) => {
    const baseSize = size === 'small' ? 0.5 : size === 'large' ? 1.5 : 1;
    const finalSize = baseSize * snowflake.size;
    
    if (finalSize < 0.7) return 'text-xs';
    if (finalSize > 1.3) return 'text-xl';
    return 'text-base';
  };

  const getSnowflakeChar = () => {
    const chars = ['❄', '❅', '❆', '✦', '✧', '✩'];
    return chars[Math.floor(Math.random() * chars.length)];
  };

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {snowflakes.map((snowflake) => (
        <motion.div
          key={snowflake.id}
          className={`absolute ${getSizeClass(snowflake)} text-white/80`}
          style={{
            left: `${snowflake.x}%`,
            opacity: snowflake.opacity
          }}
          animate={{
            y: ['0vh', '110vh'],
            x: [0, Math.sin(snowflake.id) * 50],
            rotate: [0, 360]
          }}
          transition={{
            duration: snowflake.duration,
            repeat: Infinity,
            delay: snowflake.delay,
            ease: "linear"
          }}
        >
          {getSnowflakeChar()}
        </motion.div>
      ))}
    </div>
  );
};

export default Snowflakes;